<template>
    <div class="product-categories">
        <section class="product dubla-articulare" v-if="$route.params.product === this.$parent.products.dubla_articulare.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.dubla_articulare.profil_imagine" :alt="this.$parent.products.dubla_articulare.profil">
                <h2 class="product-title">{{ this.$parent.products.dubla_articulare.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.dubla_articulare.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.dubla_articulare.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.dubla_articulare.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.dubla_articulare.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.dubla_articulare.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.dubla_articulare.caracteristici[0].imgSrc" :alt="this.$parent.products.dubla_articulare.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.dubla_articulare.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.dubla_articulare.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.dubla_articulare.info_technice.fpp_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.dubla_articulare.info_technice.fpp_v_u5"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.dubla_articulare.caracteristici[1].imgSrc" :alt="this.$parent.products.dubla_articulare.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.dubla_articulare.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.dubla_articulare.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.dubla_articulare.info_technice.fpu_v_u3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info_presentation">
                                <img :src="this.$parent.products.dubla_articulare.caracteristici[2].imgSrc" :alt="this.$parent.products.dubla_articulare.caracteristici[2].nume">
                                <h4>{{ this.$parent.products.dubla_articulare.caracteristici[2].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.dubla_articulare.caracteristici[2].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.dubla_articulare.info_technice.ppp_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.dubla_articulare.info_technice.ppp_v_u5"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.dubla_articulare.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.dubla_articulare.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL DUBLA ARTICULARE -->

        <section class="product articulare-mediana" v-if="$route.params.product === this.$parent.products.articulare_mediana.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.articulare_mediana.profil_imagine" :alt="this.$parent.products.articulare_mediana.profil">
                <h2 class="product-title">{{ this.$parent.products.articulare_mediana.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.articulare_mediana.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.articulare_mediana.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.articulare_mediana.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.articulare_mediana.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.articulare_mediana.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.articulare_mediana.caracteristici[0].imgSrc" :alt="this.$parent.products.articulare_mediana.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.articulare_mediana.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.articulare_mediana.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.ftp_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.ftp_v_u5"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.ftp_v_p2"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.ftp_v_r1"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.articulare_mediana.caracteristici[1].imgSrc" :alt="this.$parent.products.articulare_mediana.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.articulare_mediana.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.articulare_mediana.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.fts_v_u2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info_presentation">
                                <img :src="this.$parent.products.articulare_mediana.caracteristici[2].imgSrc" :alt="this.$parent.products.articulare_mediana.caracteristici[2].nume">
                                <h4>{{ this.$parent.products.articulare_mediana.caracteristici[2].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.articulare_mediana.caracteristici[2].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.articulare_mediana.info_technice.fts_u2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.articulare_mediana.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.articulare_mediana.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL ARTICULARE MEDIANA -->

        <section class="product rezistenta-umezeala" v-if="$route.params.product === this.$parent.products.rezistenta_umezeala.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.rezistenta_umezeala.profil_imagine" :alt="this.$parent.products.rezistenta_umezeala.profil">
                <h2 class="product-title">{{ this.$parent.products.rezistenta_umezeala.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.rezistenta_umezeala.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.rezistenta_umezeala.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.rezistenta_umezeala.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.rezistenta_umezeala.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.rezistenta_umezeala.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.rezistenta_umezeala.caracteristici[0].imgSrc" :alt="this.$parent.products.rezistenta_umezeala.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.rezistenta_umezeala.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.rezistenta_umezeala.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ftu_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ftu_v_u5"></div>
                            </div>
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ftu_v_p2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.rezistenta_umezeala.caracteristici[1].imgSrc" :alt="this.$parent.products.rezistenta_umezeala.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.rezistenta_umezeala.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.rezistenta_umezeala.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ptp_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ptp_v_u3"></div>
                            </div>
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.rezistenta_umezeala.info_technice.ptp_v_u5"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.rezistenta_umezeala.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.rezistenta_umezeala.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL REZISTENTA UMEZEALA -->

        <section class="product actionare-electrica" v-if="$route.params.product === this.$parent.products.actionare_electrica.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.actionare_electrica.profil_imagine" :alt="this.$parent.products.actionare_electrica.profil">
                <h2 class="product-title">{{ this.$parent.products.actionare_electrica.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.actionare_electrica.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.actionare_electrica.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.actionare_electrica.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.actionare_electrica.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.actionare_electrica.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.actionare_electrica.caracteristici[0].imgSrc" :alt="this.$parent.products.actionare_electrica.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.actionare_electrica.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.actionare_electrica.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftp_v_z_wave_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftp_v_z_wave_u5"></div>
                            </div>
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftp_v_z_wave_p2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.actionare_electrica.caracteristici[1].imgSrc" :alt="this.$parent.products.actionare_electrica.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.actionare_electrica.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.actionare_electrica.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftu_v_z_wave_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftu_v_z_wave_u3"></div>
                            </div>
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.actionare_electrica.info_technice.ftu_v_z_wave_u3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.actionare_electrica.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.actionare_electrica.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL ACTIONARE ELECTRICA -->

        <section class="product case-pasive" v-if="$route.params.product === this.$parent.products.case_pasive.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.case_pasive.profil_imagine" :alt="this.$parent.products.case_pasive.profil">
                <h2 class="product-title">{{ this.$parent.products.case_pasive.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.case_pasive.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.case_pasive.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.case_pasive.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.case_pasive.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.case_pasive.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.case_pasive.caracteristici[0].imgSrc" :alt="this.$parent.products.case_pasive.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.case_pasive.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.case_pasive.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.case_pasive.info_technice.ftt_u6"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.case_pasive.caracteristici[1].imgSrc" :alt="this.$parent.products.case_pasive.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.case_pasive.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.case_pasive.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.case_pasive.info_technice.ftt_u8"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.case_pasive.caracteristici[2].imgSrc" :alt="this.$parent.products.case_pasive.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.case_pasive.caracteristici[2].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.case_pasive.caracteristici[2].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.case_pasive.info_technice.ftt_r3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.case_pasive.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.case_pasive.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL CASE PASIVE -->

        <section class="product antiefractie-secure" v-if="$route.params.product === this.$parent.products.antiefractie_secure.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.antiefractie_secure.profil_imagine" :alt="this.$parent.products.antiefractie_secure.profil">
                <h2 class="product-title">{{ this.$parent.products.antiefractie_secure.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.antiefractie_secure.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.antiefractie_secure.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.antiefractie_secure.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.antiefractie_secure.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.antiefractie_secure.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.antiefractie_secure.caracteristici[0].imgSrc" :alt="this.$parent.products.antiefractie_secure.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.antiefractie_secure.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.antiefractie_secure.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.antiefractie_secure.info_technice.ftp_v_p2_secure"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.antiefractie_secure.caracteristici[1].imgSrc" :alt="this.$parent.products.antiefractie_secure.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.antiefractie_secure.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.antiefractie_secure.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.antiefractie_secure.info_technice.ftu_v_p2_secure"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.antiefractie_secure.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.antiefractie_secure.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL ANTIEFRACTIE SECURE -->

        <section class="product ferestre-arc" v-if="$route.params.product === this.$parent.products.ferestre_arc.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.ferestre_arc.profil_imagine" :alt="this.$parent.products.ferestre_arc.profil">
                <h2 class="product-title">{{ this.$parent.products.ferestre_arc.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.ferestre_arc.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.ferestre_arc.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.ferestre_arc.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.ferestre_arc.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.ferestre_arc.caracteristici[0].imgSrc" :alt="this.$parent.products.ferestre_arc.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.ferestre_arc.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.ferestre_arc.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.ferestre_arc.info_technice.ftpb_z6"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.ferestre_arc.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.ferestre_arc.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE ARC -->

        <section class="product superinalte" v-if="$route.params.product === this.$parent.products.superinalte.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.superinalte.profil_imagine" :alt="this.$parent.products.superinalte.profil">
                <h2 class="product-title">{{ this.$parent.products.superinalte.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.superinalte.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.superinalte.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.superinalte.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.superinalte.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.superinalte.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.superinalte.caracteristici[0].imgSrc" :alt="this.$parent.products.superinalte.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.superinalte.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.superinalte.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.fyp_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.fyu_v_u3"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.superinalte.caracteristici[1].imgSrc" :alt="this.$parent.products.superinalte.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.superinalte.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.superinalte.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.pyp_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.fyu_v_u3_second"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.superinalte.caracteristici[2].imgSrc" :alt="this.$parent.products.superinalte.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.superinalte.caracteristici[2].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.superinalte.caracteristici[2].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.fdy_v_u3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.superinalte.info_technice.fdy_vu_u3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.superinalte.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.superinalte.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE SUPERINALTE -->

        <section class="product panoramice" v-if="$route.params.product === this.$parent.products.panoramice.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.panoramice.profil_imagine" :alt="this.$parent.products.panoramice.profil">
                <h2 class="product-title">{{ this.$parent.products.panoramice.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.panoramice.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.panoramice.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.panoramice.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.panoramice.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.panoramice.caracteristici[0].imgSrc" :alt="this.$parent.products.panoramice.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.panoramice.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.panoramice.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.panoramice.info_technice.fep_p2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.panoramice.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.panoramice.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE PANORAMICE -->

        <section class="product balcon" v-if="$route.params.product === this.$parent.products.balcon.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.balcon.profil_imagine" :alt="this.$parent.products.balcon.profil">
                <h2 class="product-title">{{ this.$parent.products.balcon.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.balcon.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.balcon.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.balcon.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.balcon.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.balcon.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.balcon.caracteristici[0].imgSrc" :alt="this.$parent.products.balcon.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.balcon.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.balcon.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.balcon.info_technice.fgh_v_p2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.balcon.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.balcon.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE BALCON -->

        <section class="product atic" v-if="$route.params.product === this.$parent.products.atic.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.atic.profil_imagine" :alt="this.$parent.products.atic.profil">
                <h2 class="product-title">{{ this.$parent.products.atic.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.atic.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.atic.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.atic.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.atic.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.atic.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.atic.caracteristici[0].imgSrc" :alt="this.$parent.products.atic.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.atic.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.atic.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bd_l3"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bd_p5"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.atic.caracteristici[1].imgSrc" :alt="this.$parent.products.atic.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.atic.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.atic.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bvp_p2"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bvp_p5"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.atic.caracteristici[2].imgSrc" :alt="this.$parent.products.atic.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.atic.caracteristici[2].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.atic.caracteristici[2].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bxp_p2"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.atic.info_technice.bxp_p5"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.atic.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.atic.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE ATIC -->

        <section class="product evacuarea-fumului" v-if="$route.params.product === this.$parent.products.evacuarea_fumului.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.evacuarea_fumului.profil_imagine" :alt="this.$parent.products.evacuarea_fumului.profil">
                <h2 class="product-title">{{ this.$parent.products.evacuarea_fumului.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.evacuarea_fumului.descriere"></div>
                <agile :options="options">
                    <div class="slide" v-for="slide in this.$parent.products.evacuarea_fumului.carousel" :key="slide.id">
                        <img :src="slide.imgSrc" :alt="slide.imgAlt">
                    </div>
                </agile>
                <h3 class="product-title">{{ this.$parent.products.evacuarea_fumului.proprietati_titlu }}</h3>
                <ul class="product-properties">
                    <li v-for="property in this.$parent.products.evacuarea_fumului.proprietati" :key="property.id">
                        <strong>{{ property.nume }}</strong>
                        <div v-html="property.dimensiuni"></div>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.evacuarea_fumului.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.evacuarea_fumului.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE EVACUAREA FUMULUI -->

        <section class="product acces-acoperis" v-if="$route.params.product === this.$parent.products.acces_acoperis.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.acces_acoperis.profil_imagine" :alt="this.$parent.products.acces_acoperis.profil">
                <h2 class="product-title">{{ this.$parent.products.acces_acoperis.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.acces_acoperis.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.acces_acoperis.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.acces_acoperis.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.acces_acoperis.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.acces_acoperis.caracteristici[0].imgSrc" :alt="this.$parent.products.acces_acoperis.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.acces_acoperis.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.acces_acoperis.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.acces_acoperis.info_technice.fwr_u3_fwl_u3"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.acces_acoperis.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.acces_acoperis.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE ACCES ACOPERIS -->

        <section class="product top" v-if="$route.params.product === this.$parent.products.top.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.top.profil_imagine" :alt="this.$parent.products.top.profil">
                <h2 class="product-title">{{ this.$parent.products.top.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.top.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.top.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.top.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.top.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.top.caracteristici[0].imgSrc" :alt="this.$parent.products.top.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.top.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.top.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.top.info_technice.fap_z6"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.top.caracteristici[1].imgSrc" :alt="this.$parent.products.top.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.top.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.top.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.top.info_technice.fap_z6"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.top.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.top.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE TOP -->

        <section class="product non-standard" v-if="$route.params.product === this.$parent.products.non_standard.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.non_standard.profil_imagine" :alt="this.$parent.products.non_standard.profil">
                <h2 class="product-title">{{ this.$parent.products.non_standard.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.non_standard.descriere"></div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE NON-STANDARD -->

        <section class="product fara-deschidere" v-if="$route.params.product === this.$parent.products.fara_deschidere.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.fara_deschidere.profil_imagine" :alt="this.$parent.products.fara_deschidere.profil">
                <h2 class="product-title">{{ this.$parent.products.fara_deschidere.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.fara_deschidere.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.fara_deschidere.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.fara_deschidere.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.fara_deschidere.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.fara_deschidere.caracteristici[0].imgSrc" :alt="this.$parent.products.fara_deschidere.caracteristici[0].nume">
                                <h4>{{ this.$parent.products.fara_deschidere.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.fara_deschidere.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.fara_deschidere.info_technice.fxp_p2"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.fara_deschidere.info_technice.fxp_p5"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <img :src="this.$parent.products.fara_deschidere.caracteristici[1].imgSrc" :alt="this.$parent.products.fara_deschidere.caracteristici[1].nume">
                                <h4>{{ this.$parent.products.fara_deschidere.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.fara_deschidere.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.fara_deschidere.info_technice.fxu_p2"></div>
                            </div>
                            <div class="col-sm-6">
                                <div v-html="this.$parent.products.fara_deschidere.info_technice.fxu_p5"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.fara_deschidere.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.fara_deschidere.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE PENTRU COMBINATII FARA DESCHIDERE-->

        <section class="product cu-deschidere" v-if="$route.params.product === this.$parent.products.cu_deschidere.nume.toLowerCase().split(' ').join('-')">

            <div class="product-inner">
                <img :src="this.$parent.products.cu_deschidere.profil_imagine" :alt="this.$parent.products.cu_deschidere.profil">
                <h2 class="product-title">{{ this.$parent.products.cu_deschidere.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.cu_deschidere.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.cu_deschidere.calitati_titlu }}</h3>
                <ul class="product-logos">
                    <li v-for="caracteristic in this.$parent.products.cu_deschidere.calitati" :key="caracteristic.id">
                            <img :src="caracteristic.imgSrc" :alt="caracteristic.nume">
                            <p>{{ caracteristic.nume }}</p>
                    </li>
                </ul>
                <h3 class="product-title">{{ this.$parent.products.cu_deschidere.info_technice.titlu }}</h3>
                <div class="product-info-wrapper">
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <h4>{{ this.$parent.products.cu_deschidere.caracteristici[0].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.cu_deschidere.caracteristici[0].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.cu_deschidere.info_technice.ftpd_p2"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product">
                        <div class="product-info">
                            <div class="product-info__presentation">
                                <h4>{{ this.$parent.products.cu_deschidere.caracteristici[1].nume }}</h4>
                            </div>
                            <div class="product-info__content" v-html="this.$parent.products.cu_deschidere.caracteristici[1].specificatii"></div>
                        </div>
                        <div class="product-characteristics row">
                            <div class="col-sm-6 offset-sm-3">
                                <div v-html="this.$parent.products.cu_deschidere.info_technice.ftud_p2"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <h3 class="product-title">{{ this.$parent.products.cu_deschidere.instructiuni_titlu }}</h3>
                <div class="instructions row">
                    <div class="instructions-unit col-sm-6" v-for="instruction in this.$parent.products.cu_deschidere.instructiuni" :key="instruction.id">
                        <strong>{{ instruction.nume }}</strong>
                        <div v-html="instruction.caracteristici"></div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL FERESTRE PENTRU COMBINATII CU DESCHIDERE-->

    </div>
    
</template>
<script>
export default {
  data() {
    return {
      name: "fakroProducts",
      options: {
        arrows: true,
        dots: true,
        speed: 750,
        fade: false,
        pauseOnHover: true,
        infinite: true,
        autoplay: true
      }
    };
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";

/*=============================================
=            EVACUAREA FUMULUI            =
=============================================*/
.evacuarea-fumului {
  .product-properties {
    display: flex;
    > li {
      padding: 1rem;
      margin-bottom: 2rem;
      width: 50%;
    }
    ul {
      li {
        border-bottom: 1px solid $light-gray;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 10px 10px 20px;
        position: relative;
        &:last-child {
          border: 0;
        }
        &:before {
          content: "";
          background-color: $secondary-color;
          border-radius: 50%;
          display: block;
          margin-right: 10px;
          position: absolute;
          top: 50%;
          left: 0;
          margin-top: -5px;
          height: 10px;
          width: 10px;
        }
      }
    }
  }
}

/*=============================================
=            NON-STANDARD            =
=============================================*/
.non-standard {
  .img-wrapper {
    margin-bottom: 1rem;
  }
  .product-description {
    .wrapper {
      border-bottom: 1px solid $light-gray;
      margin-bottom: 2rem;
      padding-bottom: 2rem;
      &:last-child {
        border: 0;
        margin: 0;
        padding: 0;
      }
    }
  }
}

/*=============================================
=            RESPONSIVE            =
=============================================*/

@media (max-width: 767.98px) {
  .page-fakro {
    .product-logos {
      justify-content: center;
    }
  }
}

@media (max-width: 575.98px) {
  .page-fakro {
    .product-logos {
      li {
        width: 100%;
      }
    }
    .product-info {
      flex-direction: column;
      &__presentation {
        margin: 0 0 1rem 0;
      }
      &__content {
        width: 100%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/fakroProducts.vue